/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SortableTableHeader from '../../../../common/SortableTableHeader/SortableTableHeader';
import { selectNotificationGroupList } from '../../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import NotificationGroupsTableRow from './NotificationGroupsTableRow/NotificationGroupsTableRow';

const columnHeaders = [
  { label: 'Name', sortType: 'name' },
  { label: 'Notifies...', sortType: 'recipients' },
  { label: 'Used in...', sortType: 'uniqueAlertCount' },
];

function NotificationGroupListTable() {
  const notificationGroupList = useSelector(selectNotificationGroupList);
  const [sortCol, setSortCol] = useState('');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [sortedList, setSortedList] = useState(notificationGroupList);

  const handleSetSortingOrder = (colName, order) => {
    setSortCol(colName);
    setSortOrder(order);
  };

  useEffect(() => {
    const sorted = [...notificationGroupList].sort((a, b) => {
      const itemA = a[sortCol];
      const itemB = b[sortCol];
      if (sortOrder === 'ASC') {
        if (itemA < itemB) {
          return -1;
        }
        if (itemA > itemB) {
          return 1;
        }
      } else {
        if (itemA > itemB) {
          return -1;
        }
        if (itemA < itemB) {
          return 1;
        }
      }
      return 0;
    });
    setSortedList(sorted);
  }, [sortCol, sortOrder, notificationGroupList]);

  return (
    <table
      className="table table-hover table-sm table-condensed table-striped my-1"
    >
      <thead className="thead-light">
        <tr>
          {columnHeaders.map((col) => (
            <React.Fragment key={col.label}>
              <SortableTableHeader
                onAscClick={
                      () => handleSetSortingOrder(col.sortType, 'ASC')
                    }
                onDescClick={() => handleSetSortingOrder(col.sortType, 'DES')}
                label={col.label}
                isSelected={col.sortType === sortCol}
              />
            </React.Fragment>
          ))}

          <th className="thead-light">
            {' '}
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedList.length > 0 && sortedList.map((notificationGroup) => (
          <React.Fragment key={notificationGroup.id}>
            <NotificationGroupsTableRow notificationGroup={notificationGroup} />
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default NotificationGroupListTable;
